import type { Editor } from '@tiptap/core';
import * as React from 'react';

/**
 * Inline colors written into outgoing email HTML. They must be concrete hex values because CSS
 * variables cannot ship in an email body.
 */
export const EMAIL_TEXT_COLORS = ['#0d0f11', '#9198a4', '#0066ff', '#8b3dc6', '#de2139', '#6bb025'];
export const DEFAULT_TEXT_COLOR = EMAIL_TEXT_COLORS[0];
/** Illusion-yellow light; same email-safe-literal rationale as EMAIL_TEXT_COLORS. */
export const HIGHLIGHT_COLOR = '#fef7d4';

export interface TextSizeOption {
	label: string;
	previewPx: number;
	/** null applies the default size (clears the font-size mark). */
	fontSize: string | null;
}

export const TEXT_SIZES: TextSizeOption[] = [
	{ label: 'Small', previewPx: 13, fontSize: '13px' },
	{ label: 'Normal', previewPx: 15, fontSize: null },
	{ label: 'Large', previewPx: 18, fontSize: '18px' },
];

export const ALIGNMENTS = ['left', 'center', 'right'] as const;

export type ComposerFormatCommand = 'bold' | 'italic' | 'underline' | 'bulletList' | 'highlight';

/** Keeps the editor selection intact while clicking formatting controls. */
export const keepEditorSelection = (event: React.MouseEvent) => event.preventDefault();

export const runComposerFormatCommand = (editor: Editor, command: ComposerFormatCommand) => {
	const chain = editor.chain().focus();
	switch (command) {
		case 'bold':
			chain.toggleBold().run();
			return;
		case 'italic':
			chain.toggleItalic().run();
			return;
		case 'underline':
			chain.toggleUnderline().run();
			return;
		case 'bulletList':
			chain.toggleBulletList().run();
			return;
		case 'highlight':
			chain.toggleHighlight({ color: HIGHLIGHT_COLOR }).run();
			return;
		default:
			return;
	}
};
